import { BASE_URL } from "../../../Utils/api";

function formatarTamanho(bytes) {
  if (bytes == null) return "—";
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

const CORES_PADRAO_PIE = [
  "#0d6efd", "#059669", "#f59e0b", "#dc3545", "#6f42c1", "#0dcaf0",
  "#20c997", "#fd7e14", "#6610f2", "#e83e8c",
];

export { BASE_URL, formatarTamanho, CORES_PADRAO_PIE };
